import React, {useEffect, useState } from 'react';
import {connect} from "react-redux";
import ContactContainer from "./ContactContainer";
import {Col, Row} from "react-bootstrap";
import ControlPanel from "./ControlPanel";
import PartnerCard from "./PartnerCard";
import ProjectRow from "./ProjectRow";
import FilesWidget from "../../../FilesWidget/components";

function MainPage (props) {
    const [showFilesWidget, setShowFilesWidget] = useState(false);

    useEffect(() => {
        // Sprawdź czy URL zawiera 'dashboard/simulations'
        const isSimulationsPage = window.location.pathname.includes('dashboard/simulations');
        setShowFilesWidget(isSimulationsPage);
    }, []);

    return (<div>
        <Row style={{marginLeft: 20, marginRight: 20, marginTop: 25}}>
            <Col xs={12} md={4}>
                <ContactContainer customerInformation={props.customerInformation}/>
            </Col>
            <Col xs={12} md={4}>
                <ControlPanel />
            </Col>
            <Col xs={12} md={4}>
                <PartnerCard />
            </Col>
        </Row>
        <Row style={{marginLeft: 35, marginRight: 25}}>
            <ProjectRow />
        </Row>
        {showFilesWidget && <FilesWidget/>}
    </div>)
}

const mapStateToProps = (state) => {
    return {
        data: state.clientPanel.mainPageReducer.rows,
        customerInformation: state.clientPanel.mainPageReducer.customerInformation,
    };
};

export default connect(mapStateToProps)(MainPage);